import styled from 'styled-components';

export const LoadErrorWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing.km8};

  fuel-typography > p {
    text-align: center;
    max-width: 468px;
  }
`;
